var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "54",
        height: "51",
        viewBox: "0 0 54 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M41.2071 0.664185H13.6709C6.65184 0.664185 0.961914 6.67447 0.961914 14.0887V37.0224C0.961914 44.4367 6.65184 50.4469 13.6709 50.4469H41.2071C48.2262 50.4469 53.9161 44.4367 53.9161 37.0224V14.0887C53.9161 6.67447 48.2262 0.664185 41.2071 0.664185ZM20.8197 37.3021H16.3186V13.8091H20.8197V37.3021ZM40.6776 31.1044C40.6776 31.6749 40.6484 32.1532 40.5505 32.5391C40.4525 32.9279 40.2539 33.353 39.9362 33.8201C39.6661 34.234 39.2928 34.701 38.803 35.2185C38.3132 35.7359 37.8869 36.1246 37.5188 36.3819C37.0767 36.7175 36.6742 36.9916 36.3088 37.0951C35.9408 37.1986 35.4907 37.3021 34.9506 37.3021H23.997V13.8091H34.9506C35.488 13.8091 35.9435 13.9126 36.3088 14.016C36.6769 14.1195 37.0793 14.3656 37.5215 14.7012C37.9134 14.9865 38.3476 15.4004 38.8268 15.9178C39.3034 16.4353 39.6767 16.8939 39.9468 17.2827C40.2645 17.7497 40.4525 18.1776 40.5505 18.5664C40.6484 18.9552 40.6776 19.4362 40.6776 20.0067V31.1044V31.1044Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M34.8759 18.5636H28.4976V32.5475H34.8759C34.95 32.5475 35.1645 32.3825 35.5802 31.9434C35.9959 31.5043 36.1759 31.3002 36.1759 31.2218V19.8893C36.1759 19.811 35.9985 19.6068 35.5802 19.1677C35.1645 18.7286 34.95 18.5636 34.8759 18.5636Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }